import { baseIconCssBySize, BaseIconProps } from "@components/Icon";
import styled from "@emotion/styled";

import { ReactComponent as VerifiedShield } from "src/assets/icons/verifiedShield.svg";

export default styled(VerifiedShield)<BaseIconProps>`
  ${(props) => baseIconCssBySize[props.size]}
`;
